import { ReactKit } from '@team/react';
import { Layout as Root } from './layout';
import { Badge } from './components/badge';

export const Avatar = ReactKit.createCompoundComponent(Root, { Badge });

Avatar.displayName = 'Avatar';
Avatar.Badge.displayName = 'AvatarBadge';
